/*
 * Question Messages
 *
 * This contains all the text for the Question component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  0: {
    defaultMessage: 'Stap je graag over een dunne balk?',
    description: 'Evenwicht',
    id: 'app.question.id.0'
  },
  1: {
    defaultMessage: 'Loop je graag heel snel?',
    description: 'Sprint',
    id: 'app.question.id.1'
  },
  2: {
    defaultMessage: `Vind jij rekoefeningen leuk?`,
    description: 'Lenigheid',
    id: 'app.question.id.2'
  },
  3: {
    defaultMessage: 'Loop je graag lang en ver?',
    description: 'Uithouding',
    id: 'app.question.id.3'
  },
  4: {
    defaultMessage: `Doe je graag buikspieroefeningen?`,
    description: 'Rompkracht',
    id: 'app.question.id.4'
  },
  5: {
    defaultMessage: 'Spring je graag hoog in de lucht?',
    description: 'Springen',
    id: 'app.question.id.5'
  },
  6: {
    defaultMessage: `Klim je graag?`,
    description: 'Klimmen',
    id: 'app.question.id.6'
  },
  7: {
    defaultMessage: 'Loop je graag snel heen en weer?',
    description: 'Wendbaarheid',
    id: 'app.question.id.7'
  },
  8: {
    defaultMessage: `Maak je graag je armen sterk?`,
    description: 'Arm Kracht',
    id: 'app.question.id.8'
  },
  9: {
    defaultMessage: 'Gooi je graag dingen ver weg?',
    description: 'Werpen',
    id: 'app.question.id.9'
  },
  10: {
    defaultMessage: 'Gooi en vang je graag een bal?',
    description: 'Oog-hand coördinatie',
    id: 'app.question.id.10'
  },
  11: {
    defaultMessage: 'Trap je graag tegen een bal?',
    description: 'Trappen',
    id: 'app.question.id.11'
  },
  12: {
    defaultMessage: 'Dans je graag op muziek?',
    description: 'Ritme',
    id: 'app.question.id.12'
  },
  13: {
    defaultMessage: 'Speel je graag in het water?',
    description: 'Water',
    id: 'app.question.id.13'
  },
  14: {
    defaultMessage: 'Sla je graag met een racket of knuppel tegen een bal?',
    description: 'Kaatsen',
    id: 'app.question.id.14'
  },
  15: {
    defaultMessage: 'Liever buiten of binnen?',
    description: 'Binnen / Buiten',
    id: 'app.question.id.15'
  },
  16: {
    defaultMessage: 'Liever in groep of alleen?',
    description: 'Team / Alleen',
    id: 'app.question.id.16'
  },
  17: {
    defaultMessage: 'Liever veel contact of weinig contact met anderen?',
    description: 'Contact / Geen Contact',
    id: 'app.question.id.17'
  }
});



// WEBPACK FOOTER //
// ./src/containers/rating/messages.js